export const FASTORDER = 'FastOrder';

export const FASTORDER_MY = 'FastOrder.my';

export const FASTORDER_BASE_URL = 'http://restaurant.fastorder.my';

export const FASTORDER_BUSINESS_URL = 'https://business.fastorder.my';

// https://restaurant.fastorder.my/attachment/images/2/2020/01/rhfi799j4R9I4RPrKH9357Zwz8jIPi.jpg
export const NOT_FOUND_IMAGE_URL = 'https://img.icons8.com/material-sharp/96/000000/no-image.png';
